import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@shared/services/translate';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
    selector: 'shopbox-command-menu',
    templateUrl: './command-menu.component.html',
    styleUrls: ['./command-menu.component.scss'],
    imports: [MatTooltip, MatCheckbox, FormsModule, ReactiveFormsModule, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, TranslatePipe]
})
export class CommandMenuComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<any> = new Subject<any>();
  @Input() menu: string[] = [
    'ALL',
    'NONE',
    'TOP_5'
  ];
  @Output() menuEmit: EventEmitter<number> = new EventEmitter<number>();
  checkboxControl: UntypedFormControl = new UntypedFormControl(false);

  @Input() set checkboxValue(val: boolean) {
    if (val !== undefined || val !== null) {
      this.checkboxControl.setValue(val);
    }
  }

  @Input() set setSelectedIndex (val: number) {
    if (val !== undefined || val !== null) {
      this.menuHandler(this.menu[val]);
    } else {
      this.checkboxControl.setValue(false, { emitEvent: false });
    }
  }

  selectedIndex: number;
  indeterminate: boolean = false;

  constructor(
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.watchCheckboxValue();
  }

  watchCheckboxValue() {
    this.checkboxControl.valueChanges.pipe(
      takeUntil(this.ngUnsubscribe),
    ).subscribe(res => {
      if (res) {
        this.menuEmit.emit(0);
        this.selectedIndex = 0;
      } else {
        this.menuEmit.emit(1);
        this.selectedIndex = 1;
      }
    });
  }

  menuHandler(item: string) {
    const index = this.menu.findIndex(element => element === item);
    if (index !== -1) {
      this.menuEmit.emit(index);
      this.selectedIndex = index;
      if (index === 1) {
        this.checkboxControl.setValue(false, { emitEvent: false });
      } else {
        this.checkboxControl.setValue(true, { emitEvent: false });
      }
      if (index === 2) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(false);
    this.ngUnsubscribe.complete();
  }

}
